import { useStore } from '@/store'
import { useSubscriptionEligibilityQuery } from '@/generated/graphql'

export function useSubscriptionEligibility() {
  const user = useStore(state => state.user)

  const { data, isLoading } = useSubscriptionEligibilityQuery(
    {},
    { enabled: !!user?.id }
  )

  return {
    isSubscriber: data?.subscriptionEligibility?.isSubscriber ?? false,
    hasHadSubscriptionBefore: data?.subscriptionEligibility?.hasHadSubscriptionBefore ?? false,
    isEligibleForTrial: data?.subscriptionEligibility?.isEligibleForTrial ?? true,
    hasPausedSubscription: data?.subscriptionEligibility?.hasPausedSubscription ?? false,
    hasDelinquentSubscription: data?.subscriptionEligibility?.hasDelinquentSubscription ?? false,
    isLoading,
    isLoggedIn: !!user?.id,
  }
}

